// extracted by mini-css-extract-plugin
export default {"attributeEntry":"attribute-entry_attributeEntry__CZLu8","selected":"attribute-entry_selected__EXlS3","description":"attribute-entry_description__m86C9"};